import Vue from 'vue';
import { PiniaVuePlugin } from 'pinia';

Vue.use(PiniaVuePlugin);
